import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ExInput } from "../../extras/Input";
import Button from "../../extras/Button";
import { closeDialog } from "../../../redux/slice/dialogueSlice";
import { Box, Modal } from "@mui/material";

const CompleteBookingDetails = () => {
    const { dialogueData } = useSelector((state) => state.dialogue);
    const dispatch = useDispatch();
    const [mongoId, setMongoId] = useState("");

    console.log("dialogueData", dialogueData);
    useEffect(() => {
        if (dialogueData) {
            setMongoId(dialogueData);
        }
    }, [dialogueData]);

    return (
        <Modal
            open={true}
            onClose={closeDialog}
        >
            <Box className="model-style">
                <div className="model-header">
                    <p className="m-0">Booking Info</p>
                </div>

                <div className="model-body">
                    <div className="col-12">
                        <ExInput
                            type={`text`}
                            id={`reason`}
                            name={`reason`}
                            label={`check in time`}
                            placeholder={`Reason`}
                            value={mongoId?.checkInTime}
                            disabled={true}
                        />
                    </div>
                    <div className="col-12">
                        <ExInput
                            type={`text`}
                            id={`Date`}
                            name={`Date`}
                            label={`Check out time`}
                            placeholder={`Date`}
                            value={mongoId?.checkOutTime}
                            disabled={true}
                        />
                    </div>
                </div>

                <div className="model-footer">
                    <div className="m-3 d-flex justify-content-end gap-2">
                        <Button
                            className={`close-model-btn`}
                            text={`Cancel`}
                            type={`button`}
                            onClick={() => dispatch(closeDialog())}
                        />
                    </div>
                </div>

            </Box>
        </Modal>

    );
};
export default CompleteBookingDetails;
